import { TemplatePage } from './types';

const patrickDayPage: TemplatePage = {
  header: {
    color: '#9CD8B2',
    icon: 'images/video-templates/patricks-day.jpg',
    title: "St Patrick's Day Video Templates",
    title_meta: 'Easily Personalizable St. Patrick’s Day Video Templates',
    description_meta:
      'A great collection of St. Patrick’s Day free video templates along with 700+ professionally done other ' +
      'video templates that will create lasting memories and make a positive impression.',
    description:
      "Make a splash with Wave.video’s easily personalizable video templates for St Patrick's Day. Use them to " +
      'run promotions, get fun ideas and facts, or just to make the celebration memorable.'
  },
  footer: {
    category: "St Patrick's Day",
    description:
      'Wave.video’s collection of St. Patrick’s day video templates, offers you fun and beautiful choices. ' +
      'Personalization of the templates takes a few minutes, look how fast it’s done in the tutorial below. ' +
      '<br>With Wave.video - an intuitive online video Editor, anyone can make professional-looking videos in ' +
      'minutes, send them in email, post on social media, or embed them in a blog or website all from one place. ' +
      'See for yourself how easy and fun working in Wave.video is!'
  },
  content: [
    {
      type: 'templates',
      title: 'St. Patrick’s Day',
      search: {
        category: "/Holidays & Occasions/St. Patrick's Day"
      }
    },
    {
      type: 'stocks',
      title: 'St. Patrick’s Day',
      search: { name: 'St. Patrick’s Day' }
    },
    { type: 'calendar' }
  ]
};

export default patrickDayPage;
